import PropTypes from 'prop-types';
import { RFIS_SORTED_STATUSES } from '../status-types';

const rfiPushpinStatuses = RFIS_SORTED_STATUSES.reduce((results, status) => {
  results.push(`rfis-${status}`);
  return results;
}, []);

const pushpinStatusType = PropTypes.oneOf(rfiPushpinStatuses);

// eslint-disable-next-line import/prefer-default-export
export const activePushpinAttributesType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    z: PropTypes.number.isRequired,
  }),
  status: pushpinStatusType.isRequired,
  type: PropTypes.string.isRequired,
  objectId: PropTypes.string,
  viewerState: PropTypes.object,
  externalId: PropTypes.string,
  attributesVersion: PropTypes.number,
  // used to clear newly-dropped pushpin:
  isNew: PropTypes.bool,
});
